// @flow
// Libs
import { createSelector } from 'reselect'
import centerField from '@turf/center'

// Selectors
import gridFieldBbox$ from './gridBboxOfSelectedField'
import fieldSelectedForNewJob$ from 'hfty-assets-dom/src/selectors/fieldSelectedForNewJob'

export function gridOffset$ (state: Object): number {
  return state.mapModule.gridOffset
}

export default createSelector(
  [gridFieldBbox$, gridOffset$, fieldSelectedForNewJob$],
  function (selectedOnMapField: object, gridOffset: object, fieldSelectedForNewJob: Object): Array<Array<number>> {
    if (gridOffset) {
      return gridOffset
    }

    const selectedField = selectedOnMapField || fieldSelectedForNewJob
    if (selectedField && selectedField.shape) {
      const centerPoint = centerField(selectedField.shape.shapeData)
      return {
        longitude: centerPoint.geometry.coordinates[0],
        latitude: centerPoint.geometry.coordinates[1],
      }
    }

    return null
  }
)
